var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"flex justify-content-center align-items-center"},[(_vm.loading)?[_c('ProgressSpinner',{style:(_vm.style),attrs:{"strokeWidth":_vm.strokeWidth,"fill":_vm.fill,"animationDuration":_vm.animationDuration}})]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }